<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  #navMenu {
    flex-direction: column;
    display: flex;
    flex-shrink: 0;
    gap: utils.in_rem(1px);
    overflow-x: hidden;
    overflow-y: auto;

    &.expanded {
      width: utils.in_rem(168px);
    }
  }
</style>

<script>
  import {
    userStore,
    userTodosStore,
  } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Divider from "../../Divider.svelte";
  import NavItem from "../../NavItem.svelte";
  import { navItemsStore } from "../../stores/nav-items-store";
  import { sidebarIsExpanded } from "../../stores/sidebar-store.js";

  userStore.once();
  userTodosStore.once();

  $: activeDropdownId = $sidebarIsExpanded ? null : undefined;

  const dropdownCallback = (id) => () => {
    activeDropdownId = activeDropdownId === id ? null : id;
  };
</script>

<div id="navMenu" data-testid="navMenu" class:expanded={$sidebarIsExpanded}>
  {#each $navItemsStore as navItem}
    <NavItem {navItem} onclick={dropdownCallback(navItem.id)} />
    {#if activeDropdownId === navItem.id}
      {#each navItem.menu as subNavItem}
        <NavItem navItem={subNavItem} />
      {/each}
    {/if}
    {#if navItem.divider}
      <Divider />
    {/if}
  {/each}
</div>
